
import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  orgDataService,
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';

import customers from './customers';
import controller from './edit-user-customer-assignments-dialog.controller';
import template from './edit-user-customer-assignments-dialog.html';

export class dialogService {
  getOptions($event, {
    user = null,
    userCustomers = null
  }) {
    return {
      controller,
      controllerAs: 'editUserCustomerAssignmentsDialogVM',
      locals: {
        user,
        userCustomers,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.userAdmin.editUserCustomerAssignmentsDialog', [
  alerts,
  actionIcon,
  ssDialogService,
  loaderService,
  orgDataService,
  customers
])
  .service('editUserCustomerAssignmentsDialog', dialogService)
  .name;

console.log('app.components.admin.userAdmin.editUserCustomerAssignmentsDialog created');
